import { createGlobalStyle, css } from 'styled-components';

export default createGlobalStyle<{ backgroundColor?: string; isWeb?: boolean; isMobile?: boolean }>`
  *, *:before, *:after {
    box-sizing: inherit;
  }

  ::-webkit-scrollbar {
    ${({ isWeb, isMobile }) =>
      !isWeb &&
      !isMobile &&
      css`
        display: none;
      `}
  }

  ::placeholder {
    font-weight:normal;
  }

  html {
    box-sizing: border-box;
    font-size: ${({ theme }) => theme.baseFontSize};
    width: 100vw;
    overflow: hidden;
    user-select: ${({ isWeb }) => (isWeb ? 'text' : 'none')};
    ${({ isMobile }) =>
      !isMobile &&
      css`
        overscroll-behavior: none;
      `};
    ${fillHeightIfMobile}
  }

  body {
    font-size: 1.6rem;
    background-color: ${({ backgroundColor, theme }) => backgroundColor || theme.colors.supporting.accent300};
    color: ${({ theme }) => theme.components.global.textColor};
    display: flex;
    flex-direction: column;
    margin: 0;
    position: relative;
    width: 100vw;
    overflow: hidden;
    ${({ isMobile }) =>
      !isMobile &&
      css`
        overscroll-behavior: none;
      `};
    font-family: 'roboto-flex', sans-serif;
    font-stretch: 25%;
    line-height: 1.2;
    ${fillHeightIfMobile}
  }

  ${({ isMobile = false }) => {
    return isMobile
      ? css`
          #app {
            ${fillHeightForMobile}
          }
        `
      : '';
  }}

  a {
    text-decoration: none;
    color: inherit;
    -webkit-tap-highlight-color: transparent;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  input {
    font-size: inherit;
    font-family: inherit;
    font-stretch: inherit;
  }

  input, button, label {
    color: ${({ theme }) => theme.components.global.textColor};
  }

  input, button {
    font-family: inherit;
  }

  strong {
    font-weight: 600;
  }

  button {
    font-stretch: inherit;
  }

  textarea, select, input, button { outline: none; }

  label {
    font-weight: 600;
  }

  .closed {
    max-height: 0;
  }

  .sb-show-main {
    overflow: scroll;
  }

  .mb-3 {
    margin-bottom: 1rem;
  }
`;

function fillHeightIfMobile({ isMobile = false }: { isMobile?: boolean }) {
  return isMobile ? fillHeightForMobile : '';
}

export const fillHeightForMobile = css`
  height: -moz-available;
  height: -webkit-fill-available;
  height: fill-available;
`;
